import Vue from 'vue'
import { absUrl, defaultImg, defaultGoodImage, defaultHighTechImage, defaultHTImg, arrayToMap } from '~/utils/tool'
import { delay } from '~/utils/throttle'
Vue.prototype.$absUrl = absUrl
Vue.prototype.$defaultImg = defaultImg
Vue.prototype.$delay = delay
Vue.prototype.$defaultGoodImage = defaultGoodImage
Vue.prototype.$defaultHighTechImage = defaultHighTechImage
Vue.prototype.$defaultHTImg = defaultHTImg
Vue.prototype.$arrayToMap = arrayToMap
